import { useLanguage } from "../../../i18n/LanguageContext";

export default function StandardTextBlock({
  block,
  variant = "default",
}) {
  const { language } = useLanguage();

  const content = block.content || {};
  const translatedContent = block.translated_content || {};

  const variants = {
    default: {
      backgroundColor: "#ffffff",
      borderColor: "#e5e7eb",
      label: null,
    },

    note: {
      backgroundColor: "#f8fafc",
      borderColor: "#cbd5e1",
      label: "Note",
    },

    exam_note: {
      backgroundColor: "#eff6ff",
      borderColor: "#93c5fd",
      label: "MBLEx Exam Note",
    },

    mnemonic: {
      backgroundColor: "#f5f3ff",
      borderColor: "#c4b5fd",
      label: "Memory Aid",
    },

    warning: {
      backgroundColor: "#fffbeb",
      borderColor: "#f59e0b",
      label: "Important",
    },

    example: {
      backgroundColor: "#f8fafc",
      borderColor: "#d1d5db",
      label: "Example",
    },
  };

  const config =
    variants[variant] || variants.default;

  const getTranslatedText = () => {
    if (language === "zh") {
      return content.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedContent.text || null;
    }

    return null;
  };

  const translatedText = getTranslatedText();

  const translatedTitle =
    language !== "en"
      ? translatedContent.title || null
      : null;

  return (
    <div
      style={{
        padding: "18px",
        border: `1px solid ${config.borderColor}`,
        borderRadius: "14px",
        backgroundColor: config.backgroundColor,
        marginBottom: "14px",
      }}
    >
      {config.label && (
        <div
          style={{
            fontWeight: "700",
            marginBottom: "10px",
          }}
        >
          {config.label}
        </div>
      )}

      {block.title && (
        <div
          style={{
            marginBottom: "10px",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: translatedTitle ? "4px" : 0,
            }}
          >
            {block.title}
          </h3>

          {translatedTitle && (
            <div
              style={{
                color: "#6b7280",
                fontWeight: "600",
                lineHeight: "1.5",
              }}
            >
              {translatedTitle}
            </div>
          )}
        </div>
      )}

      {content.english && (
        <div
          style={{
            fontSize: "16px",
            lineHeight: "1.7",
          }}
        >
          {content.english}
        </div>
      )}

      {translatedText && (
        <div
          style={{
            marginTop: "10px",
            color: "#6b7280",
            lineHeight: "1.7",
          }}
        >
          {translatedText}
        </div>
      )}
    </div>
  );
}